/**
 * Whether the current user may respond to a blocked action or mention tied to a
 * parent user message. When the parent message has no associated user (e.g. API
 * key auth), any authenticated viewer may respond. A blocked action can also
 * name an approver (15c) — a colleague who owns the connector or the work —
 * and that person decides it whoever raised the pause.
 */
export function canCurrentUserRespondToParentUserMessage<
  TId extends string | number,
>({
  parentUserId,
  currentUserId,
  approverUserId,
}: {
  parentUserId: TId | null | undefined;
  currentUserId: TId | undefined;
  approverUserId?: TId | null;
}): boolean {
  if (
    approverUserId != null &&
    currentUserId !== undefined &&
    approverUserId === currentUserId
  ) {
    return true;
  }

  return parentUserId == null || parentUserId === currentUserId;
}
